var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Mobanner"},[_c('div',{staticClass:"bottom-img"},[_c('img',{staticClass:"top_banner",attrs:{"src":require("@/assets/images/top-pic-mobile.png")}}),_c('img',{staticClass:"right-bottombanner",attrs:{"src":require("@/assets/images/right-bottombanner.png")}})])])
}]

export { render, staticRenderFns }